module.exports = __webpack_public_path__ + "static/img/img_nfuMainPcNew2.5e98737.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/etc/img_nfuMainPcNew2.jpeg
// module id = SNpy
// module chunks = 1